<template>
    <div class="revenue-wizard">
        <wizard v-if="state === states.wizard" :id="target.id" @close="closeWizard"></wizard>
        <div class="card" v-else>
            <div class="card-header">
                <h4 class="card-title mb-0">
                    <i class="ion-ios-list icon-fw mr-3"></i>
                    {{ 'admin.revenue.updates.index' | lang }}
                </h4>
            </div>
            <div class="card-body">
                <section v-if="error">There was an error loading updates.</section>
                <section v-else>
                    <div class="position-relative">
                        <t-table :columns="columns" :data="updates">
                            <template v-slot:th="{ item }">
                                {{ 'admin.revenue.updates.' + item | lang }}
                            </template>
                            <template v-slot:td-target="{ item }">
                                <strong :class="item.getColor()" class="target-column">
                                    {{formattedTarget(item.target)}}
                                </strong>
                            </template>
                            <template v-slot:td-state="{ item }">
                                <div v-if="item.status === 'unavailable'">
                                    <span class="text-muted">Unavailable</span>
                                </div>
                                <div v-else :class="item.getColor()" class="state-column">
                                    <div class="status-wrapper">
                                        <div class="status" v-if="item.status !== item.state">
                                            {{ item.status }}
                                        </div>
                                        <div class="state">
                                            {{ `admin.revenue.updates.states.${item.state}` | lang }}
                                        </div>
                                    </div>
                                    <div class="icon-wrapper">
                                        <span class="icon" :class="item.getIcon()"></span>
                                    </div>
                                </div>
                            </template>
                            <template v-slot:td-actions="{ item }">
                                <button class="btn btn-sm btn-action btn-secondary" v-if="item.canStart"
                                        @click="storeUpdate(item.target)">Start
                                </button>
                                <button class="btn btn-sm btn-action"
                                        :class="item.inProgress ? 'btn-primary' : 'btn-secondary'"
                                        v-else-if="item.hasStarted"
                                        @click="showWizard(item)">Wizard
                                </button>
                                <span v-else>Unavailable</span>
                            </template>
                        </t-table>
                        <t-loader :locked="loading"></t-loader>
                    </div>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
  import axios from 'axios';
  import TToast from '@/js/components/TToast';
  import Wizard from './RevenueUpdateWizard';
  import StatusProgressBar from "#/js/components/StatusProgressBar";
  import RevenueUpdate from "#/js/components/revenue/RevenueUpdate";

  export default {
    name: 'RevenueUpdateIndex',
    components: {
      Wizard,
      StatusProgressBar,
    },
    data() {
      return {
        states: {
          index: 'index',
          wizard: 'wizard',
        },
        state: 'index',
        sequence: [],
        target: null,
        columns: ['id', 'target', 'state', 'started', 'completed', 'actions'],
        updates: [],
        error: false,
        loading: true,
        locked: false,
        toast: new TToast,
      };
    },
    mounted() {
      this.getUpdates();
    },
    methods: {

      lock() {
        this.locked = true;
      },
      unlock() {
        this.locked = false;
      },
      formattedTarget(targetDate) {
        return moment.tz(targetDate, 'YYYY-MM', 'UTC').format('MMMM Y');
      },
      showWizard(revenueUpdate) {
        this.target = revenueUpdate;
        this.state = this.states.wizard;
      },
      closeWizard() {
        this.target = null;
        this.state = this.states.index;
        this.getUpdates();
      },
      getUpdates() {
        this.loading = true;
        axios.get('/admin/revenue/updates/load').then(response => {
          const content = response.data;
          const revenueUpdates = content.data || [];
          this.updates = revenueUpdates.map(item => new RevenueUpdate(item));
          this.sequence = content.sequence;
        }).catch(error => {
          this.toast.error(error);
          this.error = error;
        }).finally(() => {
          this.loading = false;
        });
      },
      storeUpdate(target) {
        if (this.locked) {
          return;
        }
        this.lock();

        axios.post('/admin/revenue/updates/store', {
          target: target,
        }).then(response => {
          this.getUpdates();
          this.showWizard(response.data);
          // init process
        }).catch(error => {
          this.toast.error(error.response.data.message);
        }).finally(() => {
          this.unlock();
        });
      },
    },
  };
</script>

<style lang="scss">
    .state-column {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-weight: 500;

        .icon-wrapper {
            min-width: 2rem;
            text-align: center;

            .icon {
                font-size: 1.45rem;
                vertical-align: middle;
                line-height: 0;
            }
        }

        .status-wrapper {
            text-transform: capitalize;

            .state {
                font-size: .88rem;
                font-weight: 600;
            }
        }
    }

    .target-column {
        font-size: .9rem;
        font-weight: 600;
    }

    .btn-action {
        font-size: small;
        min-width: 5rem;

        &.btn-secondary {
            font-weight: 400;
        }
    }
</style>